import { render, staticRenderFns } from "./ContentTutorialList.vue?vue&type=template&id=f2a04154"
import script from "./ContentTutorialList.vue?vue&type=script&lang=ts"
export * from "./ContentTutorialList.vue?vue&type=script&lang=ts"
import style0 from "./ContentTutorialList.vue?vue&type=style&index=0&id=f2a04154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports